<template>
  <div class="app-container">
    <div class="mx-auto max-w-[590px]">
      <div
        class="rounded-xl p-[48px] sm:p-6"
        :class="[
          mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100 shadow-primary',
        ]"
      >
        <div class="mb-[32px] text-center sm:mb-5">
          <h1 class="mb-2 text-[34px] font-semibold sm:text-[26px]">
            Please Sign in
          </h1>
          <p
            class="text-[14px] font-medium"
            :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
          >
            Please login below to access the ASCDI ITAD Association Member 
            site and/or the ASCDI Equipment Trading Network.  
            If you do not know your username or password please click on —
            <a
              href="https://www.ascdi.com/contact/"
              class="font-semibold text-primary-100 underline"
              >Request more information</a
            >.
          </p>
        </div>
        <div class="flex flex-col gap-5">
          <AppInput
            :mode="mode"
            id="username"
            title="Username"
            v-model="username"
            placeholder="Username"
          />
          <div>
            <AppLabel :mode="mode" htmlFor="password" title="Password" />
            <div class="relative flex items-center justify-between">
              <AppInput
                :mode="mode"
                id="password"
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Password"
                :hasLabel="false"
              />
              <span
                @click="showPassword = !showPassword"
                class="absolute right-4 cursor-pointer"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
              >
                <Eye v-if="!showPassword" :size="20" :stroke-width="1.75" />
                <EyeClosed v-else :size="20" :stroke-width="1.75" />
              </span>
            </div>
          </div>
          <div>
            <AppCheckbox :mode="mode" id="term-conditions" v-model="terms">
              <template #body>
                I accept the
                <RouterLink :to="{ name: 'agreement' }" class="underline"
                  >Terms and Conditions</RouterLink
                >
              </template>
            </AppCheckbox>
          </div>
        </div>
        <div class="mt-[32px] sm:mt-5">
          <AppButton
            title="Log in"
            @action="login"
            :isDisabled="!username || !password || !terms"
          />
        </div>
        <div class="mt-4 text-center">
          <a
            href="/auth/forgot-password"
            class="text-[14px] font-semibold text-primary-100 underline"
            >Forgot password?</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Eye, EyeClosed } from "lucide-vue-next";
import ApiRequest from "@L/ApiRequest";
import { useToastStore } from "@S/toast";
import { useLoaderStore } from "@S/loader";
import { useUserStore } from "@S/user";
import AppCheckbox from "@C/Form/AppCheckbox.vue";
import AppLabel from "@C/Form/AppLabel.vue";
import AppInput from "@C/Form/AppInput.vue";
import AppButton from "@C/Common/AppButton.vue";

export default {
  name: "SignIn",
  components: {
    Eye,
    EyeClosed,
    AppCheckbox,
    AppLabel,
    AppInput,
    AppButton,
  },
  setup() {
    const toastStore = useToastStore();
    const loaderStore = useLoaderStore();
    const userStore = useUserStore();
    return {
      toastStore,
      loaderStore,
      userStore,
    };
  },
  props: {
    mode: String,
  },
  data() {
    return {
      showPassword: false,
      username: "",
      password: "",
      terms: false,
    };
  },
  methods: {
    async login() {
      this.loaderStore.setIsLoading(true);
      try {
        if (!this.username) {
          this.toastStore.show("Username can't be empty", "error");
        }
        if (!this.password) {
          this.toastStore.show("Password can't be empty", "error");
        }
        const payload = {
          username: this.username,
          password: this.password,
        };
        const { data } = await ApiRequest().post(`/auth`, payload);
        if (data && data.contact) {
          this.userStore.setUser(data);
          this.$router.push({ name: "home" });
        }
      } catch (e) {
        this.toastStore.show("Invalid username or password", "error");
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
  },
};
</script>
